import { Component, Input, Output, EventEmitter, forwardRef } from '@angular/core';

import { ControlValueAccessor, NG_VALUE_ACCESSOR, FormsModule } from '@angular/forms';

@Component({
  selector: 'ui-range',
  standalone: true,
  imports: [FormsModule],
  templateUrl: './ui-range.component.html',
  styleUrl: './ui-range.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => UiRangeComponent),
      multi: true
    }
  ]
})
export class UiRangeComponent implements ControlValueAccessor {
  @Input() min: number = 0;
  @Input() max: number = 100;
  @Input() step: number = 1;
  @Input() size: 'xs' | 'sm' | 'md' | 'lg' = 'md';
  @Input() variant: 'primary' | 'secondary' | 'accent' | 'success' | 'warning' | 'info' | 'error' = 'primary';
  @Input() disabled: boolean = false;
  @Input() showSteps: boolean = false;

  @Output() valueChange = new EventEmitter<number>();

  value: number = 0;

  private onChange: (value: number) => void = () => {};
  private onTouched: () => void = () => {};

  get rangeClasses(): string {
    const classes = ['range'];

    if (this.variant) {
      classes.push(`range-${this.variant}`);
    }

    if (this.size && this.size !== 'md') {
      classes.push(`range-${this.size}`);
    }

    return classes.join(' ');
  }

  onInputChange(event: Event): void {
    const target = event.target as HTMLInputElement;
    const newValue = parseFloat(target.value);
    this.value = newValue;
    this.onChange(newValue);
    this.onTouched();
    this.valueChange.emit(newValue);
  }

  // ControlValueAccessor implementation
  writeValue(value: number): void {
    this.value = value ?? this.min;
  }

  registerOnChange(fn: (value: number) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  getStepMarkers(): number[] {
    if (!this.showSteps) return [];
    const steps: number[] = [];
    const stepCount = Math.floor((this.max - this.min) / this.step);
    for (let i = 0; i <= stepCount; i++) {
      steps.push(i);
    }
    return steps;
  }
}


